import React from 'react';
import PropTypes from 'prop-types';
import MUIAlert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import { makeStyles } from '@material-ui/core/styles';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import { colors } from '../../../theme/color-palette';
import { BOGLE_LIGHT } from '../../../constants/constant';

const useStyles = makeStyles(() => ({
	successAlertBox: {
		borderLeft: `4px solid ${colors.SUCCESS_MD}`,
		backgroundColor: colors.SUCCESS_MIN,
		'.MuiAlert-message': {
			fontSize: '14px',
			fontFamily: BOGLE_LIGHT,
			color: colors.SUCCESS_HIGH,
		},
	},
	errorAlertBox: {
		borderLeft: `4px solid ${colors.ERROR_MD}`,
		backgroundColor: colors.ERROR_MIN,
		'.MuiAlert-message': {
			fontSize: '14px',
			fontFamily: BOGLE_LIGHT,
			color: colors.ERROR_HIGH,
		},
	},
}));

const Alert = ({ open, content, ...props }) => {
	const { success } = props;
	const classes = useStyles();

	if (success) {
		return (
			<Collapse in={open}>
				<MUIAlert
					className={classes.successAlertBox}
					severity="success"
					icon={
						<CheckCircleOutlineIcon style={{ color: colors.SUCCESS_HIGH }} />
					}
					{...props}>
					{content}
				</MUIAlert>
			</Collapse>
		);
	} else {
		return (
			<Collapse in={open}>
				<MUIAlert
					className={classes.errorAlertBox}
					severity="success"
					icon={<ErrorOutlineIcon style={{ color: colors.ERROR_HIGH }} />}
					{...props}>
					{content}
				</MUIAlert>
			</Collapse>
		);
	}
};

Alert.propTypes = {
	open: PropTypes.bool,
	success: PropTypes.bool,
	content: PropTypes.any,
};

export default Alert;
